import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Alert } from '@semsis/ui/Alert';
import { ShellBar } from '@semsis/ui/ShellBar';
import { Spinner } from '@semsis/ui/Spinner';
import { useOrganization } from '@referee/graphql-client';
import { LanguageSelector } from '../components/LanguageSelector';
import styles from './TrainingLayout.module.css';

export function TrainingLayout() {
  const { t } = useTranslation();
  const { name, logo, primaryColor, welcomeText, loading, error } = useOrganization();
  // Per D-08 (73-CONTEXT.md), welcomeText is fetched from useOrganization() but deliberately
  // never rendered anywhere in this app. TRAIN-06 is therefore tracked as only partially
  // satisfied by design — this is a confirmed product decision, not an oversight. Do not
  // "fix" this by rendering welcomeText.
  void welcomeText;

  if (loading) {
    return (
      <div className={styles['layout__status']}>
        <Spinner />
      </div>
    );
  }

  // CR-01: an organization-fetch failure must not leave the app silently stuck behind the
  // spinner above forever — surface a real error state instead (75.1-VERIFICATION.md).
  if (error) {
    return (
      <div className={styles['layout__status']}>
        <Alert variant="error">{t('layout.load-error')}</Alert>
      </div>
    );
  }

  const shellBarStyle = primaryColor ? { background: `linear-gradient(135deg, ${primaryColor}, color-mix(in srgb, ${primaryColor} 70%, black))` } as React.CSSProperties : undefined;

  return (
    <div className={styles.layout}>
      <ShellBar
        title={name}
        logo={logo ? <img src={logo} alt={name} className={styles.logo} /> : undefined}
        style={shellBarStyle}
      >
        <LanguageSelector />
      </ShellBar>
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
}
